export default {
  LIST_FETCHED: 'USER_COUPONS_FETCHED',
  LIST_LOAD: 'USER_COUPONS_LOAD',
  TEMPLATES_FETCHED: 'USER_COUPONS_TEMPLATES_FETCHED',
  TEMPLATES_LOAD: 'USER_COUPONS_TEMPLATES_LOAD',
  ITEM_DETAIL: 'USER_COUPONS_DETAIL',
  BUTTON_LOAD: 'USER_COUPONS_BUTTON_LOAD',
};
